import assetPath from '/app/xinglets/lebenslauf/pages/startpage/src/assets/A4.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')